import { Component, effect, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { VehicleType } from '../../../../core/models/vehicle.model';

@Component({
  selector: 'app-vehicle-type-select',
  imports: [NgSelectComponent, ReactiveFormsModule],
  templateUrl: './vehicle-type-select.html',
  styleUrl: './vehicle-type-select.scss',
})
export class VehicleTypeSelect {
  readonly types = input<VehicleType[]>([]);
  readonly loading = input(false);
  readonly error = input<string | null>(null);
  readonly disabled = input(false);
  readonly selectedName = input<string | null>(null);

  readonly selectionChange = output<string | null>();

  readonly control = new FormControl<string | null>(null);

  constructor() {
    effect(() => {
      const name = this.selectedName();
      if (this.control.value !== name) {
        this.control.setValue(name, { emitEvent: false });
      }
    });

    effect(() => {
      if (this.disabled() || this.loading()) {
        this.control.disable({ emitEvent: false });
      } else {
        this.control.enable({ emitEvent: false });
      }
    });

    this.control.valueChanges.subscribe((value) => this.selectionChange.emit(value));
  }
}
